import _isEqual from "lodash/isEqual";
import { useEffect, useState } from "react";
import { useImmer } from "use-immer";

export const useQuantityInput = (length: number, sizeQuantity?: number[], min = 0) => {
	const defaultQuantity = Array.from({ length }, () => 0);
	const [quantity, setQuantity] = useImmer<number[]>(defaultQuantity || []);
	const [changedByUser, setChangedByUser] = useState(false);

	useEffect(() => {
		if (!changedByUser && sizeQuantity) {
			if (sizeQuantity.length === 0) return;
			if (sizeQuantity.length !== length) return;
			if (_isEqual(sizeQuantity, quantity)) return;
			setQuantity((prev) => {
				const newQuantity = [...prev];
				sizeQuantity.forEach((value, index) => {
					newQuantity[index] = value;
				});
				return newQuantity;
			});
		}
	}, [sizeQuantity, length, quantity, changedByUser, setQuantity]);

	const inputs = defaultQuantity.map((_, index) => {
		return {
			value: quantity[index] || 0,
			onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
				e.preventDefault();
				setChangedByUser(true);
				const value = Number.parseInt(e.target.value, 10);
				const empty = e.target.value === "";
				if (value >= 0) {
					return setQuantity((prev) => {
						const newQuantity = [...prev];
						newQuantity[index] = value;
						return newQuantity;
					});
				}
				if (empty) {
					return setQuantity((prev) => {
						const newQuantity = [...prev];
						newQuantity[index] = 0;
						return newQuantity;
					});
				}
			},

			increment: () => {
				setChangedByUser(true);
				setQuantity((prev) => {
					const newQuantity = [...prev];
					const value = newQuantity[index] || 0;
					newQuantity[index] = value + 1;
					return newQuantity;
				});
			},
			decrement: () => {
				setChangedByUser(true);
				setQuantity((prev) => {
					const newQuantity = [...prev];
					const value = newQuantity[index] || 0;
					if (value > 0) {
						newQuantity[index] = value - 1 > min ? value - 1 : min;
					}
					return newQuantity;
				});
			},
			update: (value: number) => {
				setChangedByUser(true);
				setQuantity((prev) => {
					const newQuantity = [...prev];
					newQuantity[index] = value > min ? value : min;
					return newQuantity;
				});
			},
			min,
		};
	});

	return inputs;
};
